import React from 'react';
import { TimelineItem, TimelineDot, Container, TimelineContent, TimelineLine, } from './styles';
var Timeline = function (_a) {
    var timelineItems = _a.timelineItems;
    var timelineContent = timelineItems.map(function (item, index) {
        var height = '100%';
        var top = '0';
        if (timelineItems.length === 1) {
            height = '0';
        }
        else if (index === 0 || index === timelineItems.length - 1) {
            height = '50%';
            if (index === 0) {
                top = '50%';
            }
        }
        return (React.createElement(TimelineItem, { key: item.key },
            React.createElement(TimelineDot, null),
            React.createElement(TimelineLine, { style: {
                    height: height,
                    top: top,
                } }),
            React.createElement(TimelineContent, null, item.content)));
    });
    return React.createElement(Container, null, timelineContent);
};
export default Timeline;
